module.exports = __webpack_public_path__ + "img/ring_r_i_0_1@3x.48e5a6a4.png";